module.exports = __webpack_public_path__ + "img/banner_left.c3c140e2.png";